import { map } from "rxjs";
import { POST } from "../../../../module/services/fetch";

export const sendCsvRequestService = (payload: {
  type: "secondaryOus" | "secondaryManagers";
  body: FormData;
}) =>
  POST(
    `admin/updloadCsv/${payload.type}`,
    payload.body,
    undefined,
    undefined,
    undefined,
    "multipart/form-data"
  ).pipe(map((response: any) => response));
